import type {EditClientNoteFormPayload} from "./edit-client-note.schema";

import {editClientNote} from "@project/sdk/sales";
import {EditClientNoteBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../../../client-keys";

export function editClientNoteMutationOptions(clientId: string, noteId: number) {
  return mutationOptions({
    mutationFn: (payload: EditClientNoteFormPayload) =>
      editClientNote(clientId, noteId, EditClientNoteBody.parse(payload)),
    mutationKey: clientMutationKeys.editClientNote,
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: clientKeys.detail(clientId)}),
        client.invalidateQueries({queryKey: clientKeys.lists()}),
      ]);
    },
  });
}
